import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=59b109ea&"
import script from "./ModalCard.vue?vue&type=script&lang=js&"
export * from "./ModalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports